import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/snaumann/Development/public_html/awo-lausitz/public/app/layouts/default.vue").then(m => m.default || m)),
  "site-default": defineAsyncComponent(() => import("/home/snaumann/Development/public_html/awo-lausitz/cms/vendors/gsmaterials/app/layouts/site/default.vue").then(m => m.default || m))
}